export default __webpack_public_path__ + "static/media/orange_1.png";